import React, {
  ComponentType,
  isValidElement,
  LazyExoticComponent,
  ReactElement,
  ReactNode,
  Suspense
} from 'react';

import Loader from '@components/loader/Loader';

type ChunkErrorBoundaryProps = {
  children: ReactNode;
};

type ChunkErrorBoundaryState = {
  hasError: boolean;
};

export class ChunkErrorBoundary extends React.Component<
  ChunkErrorBoundaryProps,
  ChunkErrorBoundaryState
> {
  state: ChunkErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(error: any) {
    if (error?.name === 'ChunkLoadError') {
      return { hasError: true };
    }

    return null;
  }

  componentDidCatch(error: any, info: any) {
    console.error('Caught in ChunkErrorBoundary:', error);
  }

  componentDidUpdate() {
    if (this.state.hasError) {
      // Reload the page on next tick to get new chunks
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return <div>Reloading...</div>;
    }

    return this.props.children;
  }
}

//used for lazy load route
const withSuspense = (
  Component: LazyExoticComponent<ComponentType<any>> | ReactElement
): ReactElement => {
  return (
    <ChunkErrorBoundary>
      <Suspense fallback={<Loader />}>
        {isValidElement(Component) ? Component : React.createElement(Component)}
      </Suspense>
    </ChunkErrorBoundary>
  );
};

export default withSuspense;
